import { useEffect } from 'react';
import { ctGameDefault, ctGameTitle } from '../../../constants/text';
import { PrivatePage } from '../../../components/private-page';
import GamesManagementGrid from '../../../features/games-management-grid';

export default function GamesManagement() {
  useEffect(() => {
    document.title = ctGameTitle + ' - Games management';

    return () => {
      // return default value when component unmounts
      document.title = ctGameDefault;
    };
  }, []);

  return (
    <PrivatePage
      className={'page-base--full'}
      breadcrumb={[
        { label: 'Dashboard', href: 'dashboard' },
        { label: 'Administration', href: '../administration' },

        {
          label: ' Games Management',
          href: 'administration/games/manage'
        }
      ]}
      pageTitle={'Administration'}>
      <GamesManagementGrid />
    </PrivatePage>
  );
}
